/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DisableSalesforceInput = {|
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type DisableSalesforceMutationVariables = {|
  input: DisableSalesforceInput
|};
export type DisableSalesforceMutationResponse = {|
  +disableSalesforce: ?{|
    +company: ?{|
      +salesforceEnabled: ?boolean,
      +newSalesforceEnabled: ?boolean,
    |}
  |}
|};
export type DisableSalesforceMutation = {|
  variables: DisableSalesforceMutationVariables,
  response: DisableSalesforceMutationResponse,
|};
*/


/*
mutation DisableSalesforceMutation(
  $input: DisableSalesforceInput!
) {
  disableSalesforce(input: $input) {
    company {
      salesforceEnabled
      newSalesforceEnabled
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DisableSalesforceInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesforceEnabled",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newSalesforceEnabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DisableSalesforceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DisableSalesforcePayload",
        "kind": "LinkedField",
        "name": "disableSalesforce",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DisableSalesforceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DisableSalesforcePayload",
        "kind": "LinkedField",
        "name": "disableSalesforce",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "DisableSalesforceMutation",
    "operationKind": "mutation",
    "text": "mutation DisableSalesforceMutation(\n  $input: DisableSalesforceInput!\n) {\n  disableSalesforce(input: $input) {\n    company {\n      salesforceEnabled\n      newSalesforceEnabled\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8c69821e6473c071485461da16fce2ce';

module.exports = node;
